const TECHNICAL_MESSAGE_PATTERNS: RegExp[] = [
  /^failed to fetch$/i,
  /^networkerror/i,
  /^load failed/i,
  /^network error/i,
  /^http error!/i,
  /^request failed$/i,
  /^internal server error$/i,
  /^unexpected token/i,
  /prisma/i,
  /econnrefused/i,
  /enotfound/i,
  /socket hang up/i,
  /\bat\s+\S+\s+\(/,
  /\.tsx?:\d+:\d+/,
  /\.js:\d+:\d+/,
];

export const DEFAULT_USER_ERROR_MESSAGE =
  "Something went wrong. Please try again in a moment.";

export function isTechnicalErrorMessage(message: string): boolean {
  return TECHNICAL_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
}

/** Maps thrown errors to a safe, user-readable message. */
export function getUserFacingErrorMessage(
  error: unknown,
  fallback: string = DEFAULT_USER_ERROR_MESSAGE,
): string {
  if (!(error instanceof Error)) {
    return fallback;
  }

  const message = error.message.trim();
  if (!message || isTechnicalErrorMessage(message)) {
    return fallback;
  }

  return message;
}
